import { render, staticRenderFns } from "./customer-care-login-cmp-extended.vue?vue&type=template&id=716c8eb0&scoped=true"
import script from "./customer-care-login-cmp-extended.vue?vue&type=script&lang=js"
export * from "./customer-care-login-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./customer-care-login-cmp-extended.vue?vue&type=style&index=0&id=716c8eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c8eb0",
  null
  
)

export default component.exports